import { useEffect, useState } from 'react'
import { PRICING, type Pricing } from '../data/content'

/**
 * Detecta el país del visitante por IP (ipapi.co, gratuita y sin API key).
 * Argentina paga en ARS; el resto del mundo en USD. Si la detección falla, USD.
 */
export function useGeoPrice(): { pricing: Pricing; isDetecting: boolean } {
  const [pricing, setPricing] = useState<Pricing>(PRICING.INTL)
  const [isDetecting, setIsDetecting] = useState(true)

  useEffect(() => {
    let cancelled = false
    const controller = new AbortController()
    const timeout = window.setTimeout(() => controller.abort(), 5000)

    async function detect() {
      try {
        const response = await fetch('https://ipapi.co/json/', { signal: controller.signal })
        if (!response.ok) throw new Error('geo lookup failed')
        const data: { country_code?: string } = await response.json()
        if (!cancelled && data.country_code === 'AR') {
          setPricing(PRICING.AR)
        }
      } catch {
        if (!cancelled) setPricing(PRICING.INTL)
      } finally {
        window.clearTimeout(timeout)
        if (!cancelled) setIsDetecting(false)
      }
    }

    detect()

    return () => {
      cancelled = true
      controller.abort()
      window.clearTimeout(timeout)
    }
  }, [])

  return { pricing, isDetecting }
}
